import { ArrowRight } from "lucide-react";

export function Hero({ onBook }: { onBook: () => void }) {
  return (
    <section className="hero" id="top">
      <div className="hero-inner">
        <div>
          <div className="eyebrow on-dark">A consultancy from the 828</div>
          <h1 className="hero-headline">
            You run the business.
            <br />
            <em>We run the wires.</em>
          </h1>
          <p className="hero-lead">
            Automate828 builds, migrates, and connects the software that small
            businesses actually depend on — databases, integrations, dashboards,
            document and mail workflows, the unglamorous plumbing. We use AI to
            move faster. A human is always at the wheel.
          </p>
          <div className="hero-ctas">
            <button className="btn btn-petal" onClick={onBook}>
              Book a free intro
              <ArrowRight className="btn-arrow" size={16} />
            </button>
            <a className="btn btn-on-dark" href="#services">
              See what we do
            </a>
          </div>
          <div className="hero-meta">
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: "#5BC742",
                }}
              />
              {" "}Taking work · summer ’26
            </span>
            <span>·</span>
            <span>Asheville · Hendersonville · remote</span>
          </div>
        </div>
        <div className="hero-mark">
          <img src="/logo-master.png" alt="Automate828 bloom logo" />
        </div>
      </div>
    </section>
  );
}
